/**
 * Shared marketplace category images used across the site.
 * Order matches API categories list.
 */
export const MARKETPLACE_CATEGORY_IMAGES = [
  require('@/assets/images/PartitionsLogos/icon-market-camel.png'),
  require('@/assets/images/PartitionsLogos/icon-market-animal-food.png'),
  require('@/assets/images/PartitionsLogos/icon-market-products.png'),
  require('@/assets/images/PartitionsLogos/icon-market-feed.png'),
  require('@/assets/images/PartitionsLogos/icon-market-supplies.png'),
  require('@/assets/images/PartitionsLogos/icon-market-accessories.png'),
  require('@/assets/images/PartitionsLogos/icon-market-microchip.png')
]

export const MARKETPLACE_CATEGORY_SWIPER_IMAGES = [
  {
    name: 'متاجر الإبل',
    image: require('@/assets/images/PartitionsLogos/icon-market-camel.png')
  },
  {
    name: 'متاجر الأعلاف',
    image: require('@/assets/images/PartitionsLogos/icon-market-animal-food.png')
  },
  {
    name: 'متاجر منتجات الإبل',
    image: require('@/assets/images/PartitionsLogos/icon-market-products.png')
  },
  {
    name: 'متاجر الأغذية',
    image: require('@/assets/images/PartitionsLogos/icon-market-feed.png')
  },
  {
    name: 'متاجر مستلزمات الإبل',
    image: require('@/assets/images/PartitionsLogos/icon-market-supplies.png')
  },
  {
    name: 'إكسسوارات الإبل',
    image: require('@/assets/images/PartitionsLogos/icon-market-accessories.png')
  },
  {
    name: 'متاجر الشريحة الإلكترونية',
    image: require('@/assets/images/PartitionsLogos/icon-market-microchip.png')
  }
]
